/*
 * @Author: liyihui
 * @Date:
 * @description: 接口请求访问地址 micro-refcd微服务总集
 * @Last Modified by:
 * @Last Modified time:
 */

import { BJget, BJpost, BJput, BJdel } from '@/utils/requestTeamBJ.js';

// 微服务地址
const serviceAddress = 'micro-refcd/';
// 四种请求
export function microRefcdGET(address, data, func) {
	BJget(serviceAddress + address, data).then(res => { func(res); });
}
export function microRefcdPOST(address, data, func) {
	BJpost(serviceAddress + address, data).then(res => { func(res); });
}
export function microRefcdPUT(address, data, func) {
	BJput(serviceAddress + address, data).then(res => { func(res); });
}
export function microRefcdDEL(address, data, func) {
	BJdel(serviceAddress + address, data).then(res => { func(res); });
}


// 放出本微服务API接口合集
import refgrpAPI from './refgrp'; // 配置项

const API = {
    ...refgrpAPI,
}

export default API;



// WEBPACK FOOTER //
// ./src/api/microRefcd/index.js